<template>
    <section
        class="relative bg-gradient-to-t from-transparent via-accent/10 via-25% to-transparent">
        <div class="container">
            <div class="flex items-center justify-between">
                <AtomTitle> {{ title }} </AtomTitle>
                <div class="hidden space-x-3 md:flex">
                    <ArrowButton
                        id="portfolio-products-prev"
                        class="rotate-180" />
                    <ArrowButton id="portfolio-products-next" />
                </div>
            </div>
            <div>
                <div
                    class="swiper swiper-portfolio-products"
                    :class="isCromi() ? '!pr-5' : ''">
                    <div class="swiper-wrapper mt-5 md:mt-10 md:items-stretch">
                        <div
                            v-for="product in items"
                            :key="product.slug"
                            class="swiper-slide !h-auto max-md:!w-[17.5rem]">
                            <div class="swiper-slide__inner h-full">
                                <ProductCard
                                    target="_blank"
                                    :product />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import ArrowButton from '~/components/base/arrow-button/ArrowButton.vue'
import ProductCard from '~/components/particles/product-card/ProductCard.vue'
import type { IProductCard } from '~/components/particles/product-card/product-card.types'

import { useCartProductLimits } from '~/composables/useCartProductLimits'

const props = defineProps({
    items: {
        type: Array as PropType<IProductCard[]>,
        default: () => [],
    },
    title: {
        type: String as PropType<string>,
        default: 'В проекте было использовано:',
    },
})

const { applyProductLimits } = useCartProductLimits()

watch(
    () => props.items,
    (items) => {
        applyProductLimits(items)
    },
    {
        immediate: true,
        deep: true,
    }
)

onMounted(() => {
    new Swiper('.swiper-portfolio-products', {
        modules: [Navigation],
        navigation: {
            prevEl: '#portfolio-products-prev',
            nextEl: '#portfolio-products-next',
        },
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
            320: {
                spaceBetween: 8,
            },
            375: {
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
    })
})
</script>
